module.exports = __webpack_public_path__ + "img/sun-behind-large-cloud.9148cca8.png";